(function () {
  const root = document.querySelector('[data-powdi-arecipe]');
  if (!root) return;

  const scroller = root.querySelector('[data-related-scroll]');
  const thumb = root.querySelector('[data-related-thumb]');
  const recipeScroller = root.querySelector('[data-recipe-scroll]');
  const recipeThumb = root.querySelector('[data-recipe-thumb]');

  const bindScroll = (el, marker) => {
    if (!el || !marker) return;
    const update = () => {
      const track = marker.parentElement;
      if (!track) return;
      const max = el.scrollWidth - el.clientWidth;
      const thumbWidth = Math.max(
        47,
        Math.round(track.clientWidth * (el.clientWidth / Math.max(el.scrollWidth, 1)))
      );
      const ratio = max > 0 ? el.scrollLeft / max : 0;
      marker.style.width = `${thumbWidth}px`;
      marker.style.transform = `translateX(${ratio * (track.clientWidth - thumbWidth)}px)`;
    };
    el.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  bindScroll(scroller, thumb);
  bindScroll(recipeScroller, recipeThumb);

  root.querySelectorAll('[data-share-copy]').forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.getAttribute('data-share-url') || window.location.href;
      const title = document.title;
      try {
        if (navigator.share) {
          await navigator.share({ title, url });
          return;
        }
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
      try {
        await navigator.clipboard.writeText(url);
        button.setAttribute('data-copied', 'true');
        window.setTimeout(() => button.removeAttribute('data-copied'), 2000);
      } catch (_error) {
        window.prompt(title, url);
      }
    });
  });

  const sheet = root.querySelector('[data-recipe-sheet]');

  const fillSheet = () => {
    if (!sheet) return;
    const title = root.querySelector('.powdi-arecipe__title')?.textContent?.trim() || document.title;
    const titleNode = sheet.querySelector('[data-sheet-title]');
    if (titleNode) titleNode.textContent = title;

    const photo = sheet.querySelector('[data-sheet-photo]');
    const source = root.querySelector('.powdi-arecipe__photo img');
    if (photo) {
      let src = '';
      let bestWidth = 0;
      (source?.getAttribute('srcset') || '').split(',').forEach((part) => {
        const bits = part.trim().split(/\s+/);
        const width = parseInt(bits[1], 10) || 0;
        if (bits[0] && width >= bestWidth) {
          bestWidth = width;
          src = bits[0];
        }
      });
      if (!src) src = source?.currentSrc || source?.src || '';
      if (src) {
        photo.src = src;
        photo.alt = title;
        photo.hidden = false;
      } else {
        photo.removeAttribute('src');
        photo.hidden = true;
      }
    }

    const meta = sheet.querySelector('[data-sheet-meta]');
    if (meta) {
      const bits = [...root.querySelectorAll('.powdi-arecipe__chip')].map((chip) =>
        chip.textContent.replace(/\s+/g, ' ').trim().replace(/:\s*$/, '')
      ).filter(Boolean);
      meta.textContent = bits.join('  ·  ');
      meta.hidden = bits.length === 0;
    }

    const ingredients = sheet.querySelector('[data-sheet-ingredients]');
    if (ingredients) {
      ingredients.replaceChildren();
      root.querySelectorAll('.powdi-arecipe__block').forEach((block) => {
        if (!block.querySelector('.powdi-arecipe__ingredients, .powdi-arecipe__ingredient')) return;
        block.querySelectorAll('.powdi-arecipe__subhead, .powdi-arecipe__ingredient').forEach((node) => {
          const textNode = node.querySelector('.powdi-arecipe__ingredient-text') || node;
          const text = textNode.textContent.replace(/\s+/g, ' ').trim();
          if (!text) return;
          const item = document.createElement('li');
          if (node.classList.contains('powdi-arecipe__subhead')) item.className = 'is-subhead';
          item.textContent = text;
          ingredients.appendChild(item);
        });
      });
    }

    const method = sheet.querySelector('[data-sheet-method]');
    if (method) {
      method.replaceChildren();
      const methodRoot = root.querySelector('.powdi-arecipe__copy--method');
      const steps = [];
      methodRoot?.querySelectorAll('.powdi-arecipe__line, li').forEach((node) => {
        const text = node.textContent.replace(/\s+/g, ' ').trim();
        if (text) steps.push(text.replace(/^\d+[\.\)]\s*/, ''));
      });
      if (!steps.length && methodRoot) {
        methodRoot.textContent
          .split(/\n+/)
          .map((line) => line.replace(/\s+/g, ' ').trim())
          .filter(Boolean)
          .forEach((line) => steps.push(line.replace(/^\d+[\.\)]\s*/, '')));
      }
      steps.forEach((text) => {
        const item = document.createElement('li');
        item.textContent = text;
        method.appendChild(item);
      });
    }

    const ingredientCount = sheet.querySelector('[data-sheet-ingredients]')?.children.length || 0;
    const stepCount = sheet.querySelector('[data-sheet-method]')?.children.length || 0;
    sheet.classList.toggle('is-compact', ingredientCount + stepCount > 16);
  };

  const printSheet = () => {
    if (!sheet) return;
    fillSheet();
    const previousTitle = document.title;
    const recipeTitle = root.querySelector('.powdi-arecipe__title')?.textContent?.trim();
    if (recipeTitle) document.title = recipeTitle;
    const home = sheet.parentElement;
    document.body.appendChild(sheet);
    document.documentElement.classList.add('powdi-recipe-printing');
    const restore = () => {
      document.documentElement.classList.remove('powdi-recipe-printing');
      document.title = previousTitle;
      if (home) home.insertBefore(sheet, home.firstChild);
      window.removeEventListener('afterprint', restore);
    };
    window.addEventListener('afterprint', restore);
    const photo = sheet.querySelector('[data-sheet-photo]');
    if (photo && !photo.hidden && photo.src && !photo.complete) {
      const go = () => window.print();
      photo.addEventListener('load', go, { once: true });
      photo.addEventListener('error', go, { once: true });
      return;
    }
    window.print();
  };

  const recipeSlug = (title) =>
    title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'receptas';

  const loadImage = (src) =>
    new Promise((resolve) => {
      if (!src) {
        resolve(null);
        return;
      }
      const image = new Image();
      image.onload = () => resolve(image.naturalWidth ? image : null);
      image.onerror = () => resolve(null);
      image.src = src;
    });

  // The saved sheet draws the wordmark at 44px. Rasterize the vector at 3× first
  // so the curves stay sharp when the canvas scales them down.
  const loadSharpLogo = async (src) => {
    const pixelHeight = 44 * 3;
    try {
      const response = await fetch(src);
      if (!response.ok) throw new Error('logo');
      const parsed = new DOMParser().parseFromString(await response.text(), 'image/svg+xml');
      const svg = parsed.documentElement;
      const box = (svg.getAttribute('viewBox') || '0 0 1060.3 388.8').trim().split(/[\s,]+/).map(Number);
      const boxWidth = box[2] || 1060.3;
      const boxHeight = box[3] || 388.8;
      svg.setAttribute('width', String(Math.round(pixelHeight * (boxWidth / boxHeight))));
      svg.setAttribute('height', String(pixelHeight));
      const blob = new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const image = await loadImage(url);
      URL.revokeObjectURL(url);
      if (image) return image;
    } catch (_error) {
      /* The plain image is still the same vector, just at its file size. */
    }
    return loadImage(src);
  };

  const wrapLines = (context, text, maxWidth) => {
    const words = String(text || '').split(/\s+/).filter(Boolean);
    const lines = [];
    let line = '';
    words.forEach((word) => {
      const next = line ? `${line} ${word}` : word;
      if (line && context.measureText(next).width > maxWidth) {
        lines.push(line);
        line = word;
      } else {
        line = next;
      }
    });
    if (line) lines.push(line);
    return lines.length ? lines : [''];
  };

  const jpegToPdf = (dataUrl, width, height) => {
    const bytes = Uint8Array.from(atob(dataUrl.split(',')[1]), (char) => char.charCodeAt(0));
    const pageWidth = 595;
    const pageHeight = 842;
    const content = `q\n${pageWidth} 0 0 ${pageHeight} 0 0 cm\n/Im0 Do\nQ\n`;
    const encoder = new TextEncoder();
    const chunks = [encoder.encode('%PDF-1.4\n')];
    const offsets = [];
    const mark = () => chunks.reduce((sum, chunk) => sum + chunk.length, 0);
    const add = (value) => {
      offsets.push(mark());
      chunks.push(typeof value === 'string' ? encoder.encode(value) : value);
    };
    add('1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n');
    add('2 0 obj\n<< /Type /Pages /Kids [3 0 R] /Count 1 >>\nendobj\n');
    add(
      `3 0 obj\n<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageWidth} ${pageHeight}] /Contents 4 0 R /Resources << /XObject << /Im0 5 0 R >> >> >>\nendobj\n`
    );
    add(`4 0 obj\n<< /Length ${content.length} >>\nstream\n${content}endstream\nendobj\n`);
    add(
      `5 0 obj\n<< /Type /XObject /Subtype /Image /Width ${width} /Height ${height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${bytes.length} >>\nstream\n`
    );
    chunks.push(bytes);
    chunks.push(encoder.encode('\nendstream\nendobj\n'));
    const xref = mark();
    let table = `xref\n0 6\n0000000000 65535 f \n`;
    offsets.forEach((offset) => {
      table += `${String(offset).padStart(10, '0')} 00000 n \n`;
    });
    table += `trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF`;
    chunks.push(encoder.encode(table));
    return new Blob(chunks, { type: 'application/pdf' });
  };

  const saveSheet = async () => {
    if (!sheet) return;
    fillSheet();
    const title = root.querySelector('.powdi-arecipe__title')?.textContent?.trim() || 'Receptas';
    const meta = sheet.querySelector('[data-sheet-meta]');
    const ingredients = [...(sheet.querySelector('[data-sheet-ingredients]')?.children || [])].map((item) => ({
      text: item.textContent.replace(/\s+/g, ' ').trim(),
      sub: item.classList.contains('is-subhead')
    }));
    const steps = [...(sheet.querySelector('[data-sheet-method]')?.children || [])].map((item) =>
      item.textContent.replace(/\s+/g, ' ').trim()
    );
    const ingredientLabel = sheet.querySelector('[data-sheet-ingredients]')?.previousElementSibling?.textContent?.trim() || 'Ingredientai:';
    const methodLabel = sheet.querySelector('[data-sheet-method]')?.previousElementSibling?.textContent?.trim() || 'Gaminimo eiga:';
    const photo = sheet.querySelector('[data-sheet-photo]');
    const logo = sheet.querySelector('.powdi-recipe-sheet__logo');
    await document.fonts?.ready;
    const [photoImage, logoImage] = await Promise.all([
      loadImage(photo && !photo.hidden ? photo.currentSrc || photo.src : ''),
      loadSharpLogo(logo?.currentSrc || logo?.src || '')
    ]);

    const width = 1190;
    const height = 1684;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    const forest = '#1a3b2a';
    const pad = 64;
    const metaText = meta && !meta.hidden ? meta.textContent.replace(/\s+/g, ' ').trim() : '';
    const methodRows = steps.map((text) => ({ text, sub: false }));
    const drawPage = (compact) => {
      const bodySize = compact ? 17 : 22;
      const bodyLeading = compact ? 23 : 32;
      const photoHeight = photoImage ? (compact ? 280 : 420) : 0;
      const titleSize = compact ? 34 : 44;
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, width, height);
      context.fillStyle = forest;
      context.textBaseline = 'top';
      context.textAlign = 'left';

      if (logoImage) {
        const logoHeight = 44;
        const logoWidth = (logoImage.naturalWidth / logoImage.naturalHeight) * logoHeight;
        context.drawImage(logoImage, pad, 40, logoWidth, logoHeight);
      } else {
        context.font = '700 32px Sora, sans-serif';
        context.fillText('powdi', pad, 44);
      }
      context.font = '700 24px Sora, sans-serif';
      context.textAlign = 'right';
      context.fillText('powdi.lt', width - pad, 48);
      context.textAlign = 'left';

      let y = 108;
      if (photoImage) {
        context.save();
        context.beginPath();
        context.roundRect(pad, y, width - pad * 2, photoHeight, 16);
        context.clip();
        const scale = Math.max((width - pad * 2) / photoImage.naturalWidth, photoHeight / photoImage.naturalHeight);
        const drawnWidth = photoImage.naturalWidth * scale;
        const drawnHeight = photoImage.naturalHeight * scale;
        context.drawImage(
          photoImage,
          pad + (width - pad * 2 - drawnWidth) / 2,
          y + (photoHeight - drawnHeight) / 2,
          drawnWidth,
          drawnHeight
        );
        context.restore();
        y += photoHeight + 24;
      }

      context.font = `700 ${titleSize}px Sora, sans-serif`;
      wrapLines(context, title, width - pad * 2).forEach((line) => {
        context.fillText(line, pad, y);
        y += titleSize + 8;
      });
      if (metaText) {
        y += 4;
        context.font = '400 20px Sora, sans-serif';
        wrapLines(context, metaText, width - pad * 2).forEach((line) => {
          context.fillText(line, pad, y);
          y += 28;
        });
      }
      y += 16;

      const colGap = 36;
      const colWidth = (width - pad * 2 - colGap) / 2;
      const drawList = (x, label, rows, numbered) => {
        let columnY = y;
        context.font = '700 22px Sora, sans-serif';
        context.fillText(label, x, columnY);
        columnY += 34;
        let number = 0;
        rows.forEach((row) => {
          if (row.sub) {
            columnY += 6;
            context.font = `700 ${bodySize}px Sora, sans-serif`;
            wrapLines(context, row.text, colWidth).forEach((line) => {
              context.fillText(line, x, columnY);
              columnY += bodyLeading;
            });
            return;
          }
          number += 1;
          context.font = `400 ${bodySize}px Sora, sans-serif`;
          const prefix = numbered ? `${number}. ` : '• ';
          wrapLines(context, `${prefix}${row.text || row}`, colWidth).forEach((line, lineIndex) => {
            context.fillText(lineIndex ? `    ${line}` : line, x, columnY);
            columnY += bodyLeading;
          });
        });
        return columnY;
      };
      const leftBottom = drawList(pad, ingredientLabel, ingredients, false);
      const rightBottom = drawList(pad + colWidth + colGap, methodLabel, methodRows, true);
      return Math.max(leftBottom, rightBottom);
    };
    if (drawPage(false) > height - 48) drawPage(true);

    let jpeg = '';
    try {
      jpeg = canvas.toDataURL('image/jpeg', 0.92);
    } catch (_error) {
      printSheet();
      return;
    }
    const blob = jpegToPdf(jpeg, width, height);
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${recipeSlug(title)}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(link.href), 1500);
  };

  root.querySelector('[data-recipe-print]')?.addEventListener('click', printSheet);
  root.querySelector('[data-recipe-save]')?.addEventListener('click', saveSheet);
})();
